const constants = {
    AGE_SAVINGS_LIMIT: 55,
    GUIDE_RESULT_ADD_BUTTON_SEK_INTERVAL: 1000,
};

export default constants;